import { MAX_HEIGHT } from "./constants";
import { mergeRefs } from "react-merge-refs";
import { motion } from "framer-motion";
import { useEventCallbacks } from "./hooks";
import { useSheetContext } from "./context";
import * as React from "react";
import styles from "./styles";
const SheetContainer = React.forwardRef(({ children, style = {}, ...rest }, ref) => {
    const { y, isOpen, callbacks, snapPoints, initialSnap = 0, sheetRef, windowHeight, detent, animationOptions, reduceMotion, } = useSheetContext();
    const { handleAnimationComplete } = useEventCallbacks(isOpen, callbacks);
    const initialY = snapPoints ? snapPoints[0] - snapPoints[initialSnap] : 0;
    const maxSnapHeight = snapPoints ? snapPoints[0] : null;
    const height = maxSnapHeight !== null ? `min(${maxSnapHeight}px, ${MAX_HEIGHT})` : MAX_HEIGHT;
    return (React.createElement(motion.div, { ...rest, ref: mergeRefs([sheetRef, ref]), className: "react-modal-sheet-container", style: {
            ...styles.container,
            ...style,
            ...(detent === "full-height" && { height }),
            ...(detent === "content-height" && { maxHeight: height }),
            y,
        }, initial: reduceMotion ? false : { y: windowHeight }, animate: { y: initialY, transition: animationOptions }, exit: { y: windowHeight, transition: animationOptions }, onAnimationComplete: handleAnimationComplete }, children));
});
SheetContainer.displayName = "SheetContainer";
;
export default SheetContainer;
//# sourceMappingURL=sheet-container.js.map